import './modal.less';

import { CSSTransition } from 'react-transition-group';
import { useEffect }     from 'react';
import classnames        from 'classnames';
import React             from 'react';
import ReactDOM          from 'react-dom';


const transitionClassNames = {
  enter:       'enter',
  enterActive: 'entered',
  enterDone:   'entered',
  exit:        'exit',
  exitActive:  'exited',
  exitDone:    'exited'
};

const escapeKeys = [ 'Escape', 'Esc' ];

export default function Modal({ isOpen, closeModal, children, className, onClick, onClickOverlay }) {
  const classNames = classnames('modal', className);

  useEffect(function() {
    function closeOnEscape(event) {
      if (escapeKeys.includes(event.key))
        closeModal();
    }
    if (isOpen)
      document.addEventListener('keyup', closeOnEscape);
    return () => {
      document.removeEventListener('keyup', closeOnEscape);
    };
  }, [ isOpen, closeModal ]);

  return ReactDOM.createPortal((
    <CSSTransition in={isOpen} timeout={500} classNames={transitionClassNames} mountOnEnter unmountOnExit>
      <div className={classNames} onClick={onClick}>
        <div className="modal-overlay" onClick={onClickOverlay}/>
        <div className="modal-container">
          <div className="modal-content">
            {children}
          </div>
        </div>
      </div>
    </CSSTransition>
  ), document.body);
}
